const browserOrigin = typeof window !== 'undefined' ? window.location.origin : '';
const defaultApiOrigin = process.env.NODE_ENV === 'production'
  ? 'https://api.pdl-hub.space'
  : browserOrigin;

export const API_BASE_URL = String(
  process.env.REACT_APP_API_URL || defaultApiOrigin
).replace(/\/+$/, '');

export const PANEL_LOGIC_BASE_URL = String(
  process.env.REACT_APP_PANEL_LOGIC_URL || API_BASE_URL
).replace(/\/+$/, '');

export const OFFER_IMAGE_BASE_URL = String(
  process.env.REACT_APP_OFFER_IMAGE_API_BASE_URL || API_BASE_URL
).replace(/\/+$/, '');

export const LEGACY_OFFER_IMAGE_BASE_URL = String(
  process.env.REACT_APP_LEGACY_OFFER_IMAGE_BASE_URL || `${OFFER_IMAGE_BASE_URL}/static/offers/images`
).replace(/\/+$/, '');

export const GENERAL_ORIGIN_IP = process.env.REACT_APP_GENERAL_ORIGIN_IP || '37.27.0.169';
export const STATIC_HOSTING_IP = process.env.REACT_APP_STATIC_HOSTING_IP || '';
export const KEITARO_ORIGIN_IP = process.env.REACT_APP_KEITARO_ORIGIN_IP || '';
export const PDL_RUNTIME_ROOT = process.env.REACT_APP_RUNTIME_ROOT || '/var/www/pdl';
